import React, { Component } from 'react';
const products = [{
  name: 'Chmer HM43(G)T Ball Screw High Speed Graphite Mill',
  image: 'https://cdn.magicpatterns.com/uploads/c9AbrHcYHH7y8FER9wWbMv/Diamond_Abrasive_Saw.jpg',
  href: '#'
}, {
  name: 'Chmer HM65(G)T Ball Screw High Speed Graphite & Hard Metal Mill',
  image: 'https://cdn.magicpatterns.com/uploads/c9AbrHcYHH7y8FER9wWbMv/Diamond_Abrasive_Saw.jpg',
  href: '#'
}, {
  name: 'Chmer HM4030L Linear Motor High Speed Graphite Mill',
  image: 'https://cdn.magicpatterns.com/uploads/c9AbrHcYHH7y8FER9wWbMv/Diamond_Abrasive_Saw.jpg',
  href: '#'
}, {
  name: 'Chmer HM6050L Linear Motor High Speed Mill',
  image: 'https://cdn.magicpatterns.com/uploads/c9AbrHcYHH7y8FER9wWbMv/Diamond_Abrasive_Saw.jpg',
  href: '#'
}];
export function ChmerHMSeriesSection() {
  return <section data-id="element-1892">
      <div className="bg-[#1874cd] py-4 px-6 rounded-t-xl" data-id="element-1893">
        <h2 className="text-xl md:text-2xl font-bold text-white" data-id="element-1894">
          Chmer HM Series High Speed 3 & 4 Axis Milling
        </h2>
      </div>
      <div className="bg-white p-6 md:p-8 rounded-b-xl shadow-sm border border-gray-200 border-t-0" data-id="element-1895">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-1896">
          {products.map((product, pIndex) => <div key={pIndex} className="group bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden hover:shadow-xl hover:-translate-y-1 transition-all duration-300 flex flex-col h-full" data-id="element-1897">
              <a href="/m7_view_item.html" className="bg-gray-50 p-6 h-56 flex items-center justify-center border-b border-gray-100 block" data-id="element-1898">
                <img src={product.image} alt={product.name} className="max-w-full max-h-full object-contain group-hover:scale-105 transition-transform duration-500 block" data-id="element-1899" />
              </a>
              <div className="p-5 flex flex-col flex-grow" data-id="element-1900">
                <a href="/m7_view_item.html" className="no-underline" data-id="element-1901">
                  <h3 className="text-base font-bold text-navy mb-4 leading-tight group-hover:text-orange transition-colors" data-id="element-1902">
                    {product.name}
                  </h3>
                </a>
                <div className="mt-auto pt-4 border-t border-gray-100 flex flex-col space-y-2" data-id="element-1903">
                  <a href={`/ContactPeakMachineSales.html?i515589:default[Product%20Title]=${encodeURIComponent(product.name)}`} className="inline-flex items-center justify-center w-full bg-navy text-white px-4 py-2 rounded-md font-bold text-sm hover:bg-orange transition-colors no-underline" data-id="element-1904">
                    Request for Quote
                  </a>
                  <a href="/m7_view_item.html" className="inline-flex items-center justify-center w-full bg-gray-100 text-navy px-4 py-2 rounded-md font-bold text-sm hover:bg-gray-200 transition-colors no-underline" data-id="element-1905">
                    More Information
                  </a>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}